// const GOMO_HOSTNAME_MATCHES = ['localhost'];
// const EIR_HOSTNAME_MATCHES = ['localhost'];
const GOMO_HOSTNAME_MATCHES = ['gomo', 'ion'];
const EIR_HOSTNAME_MATCHES = ['eir'];

export const getGalaxionBrand = () => {
  const hostName = window.location.hostname.toLowerCase();
  const matchesBrand = values => values.some(value => hostName.includes(value));

  if (matchesBrand(GOMO_HOSTNAME_MATCHES)) {
    return 'GOMO';
  }

  if (matchesBrand(EIR_HOSTNAME_MATCHES)) {
    return 'EIR';
  }

  return null;
};
